import { Component, computed, inject, input } from '@angular/core';
import { DocumentItemPartial, FavoriteFieldEntity } from '@domain';
import { TranslatePipe } from '@ngx-translate/core';
import { TrashDocumentItemEntity } from 'src/app/domain/entities/trash-document-item.entity';
import { RaIconComponent } from 'src/app/shared/components/ra-icon/ra-icon.component';
import { ChartViewComponent } from '../../../../../components/chart-view/chart-view.component';
import { CHART_KIND_OPTIONS, parseChartValue } from '../../../../../chart-options';
import { RaEditTooltipDirective } from '../../../directives/ra-edit-tooltip/ra-edit-tooltip.directive';
import { EditDataService } from '../../../services/_edit-data.service';
import { ChartWizardService, ChartWizardStep } from '../../../services/chart-wizard.service';
import { EditService } from '../../../services/edit-service';
import { CardBaseComponent } from '../_card-base/card-base.component';
import { CardTypes } from '../_card-base/enums/card-types.enum';

/**
 * Card do GRÁFICO (item CHART): o gráfico como ele imprime. O conteúdo não edita no
 * lugar (é um desenho); clicar nele, ou em "Editar dados" no rail, abre o assistente nos
 * dados, e "Aparência" abre o assistente na aparência.
 */
@Component({
    selector: 'chart-card',
    templateUrl: 'chart-card.component.html',
    styleUrl: 'chart-card.component.scss',
    imports: [CardBaseComponent, ChartViewComponent, RaIconComponent, RaEditTooltipDirective, TranslatePipe],
})
export class ChartCardComponent {
    public field = input<DocumentItemPartial>();
    public favoriteField = input<FavoriteFieldEntity>();
    public trashField = input<TrashDocumentItemEntity>();
    public type = input<CardTypes>(CardTypes.DEFAULT);
    public selected = input<boolean>(false);

    public readonly cardTypes = CardTypes;

    private _wizard = inject(ChartWizardService);
    private _editService = inject(EditService);
    private _editDataService = inject(EditDataService);

    public currentField = computed<DocumentItemPartial | undefined>(() => {
        switch (this.type()) {
            case CardTypes.TRASH:
                return this.trashField()?.item;
            case CardTypes.FAVORITE:
                return this.favoriteField()?.field;
            default:
                return this.field();
        }
    });

    /** Nome do tipo ("Colunas e linha"), para o rótulo de acessibilidade do card. */
    public kindLabelKey = computed(() => {
        const kind = parseChartValue(this.currentField()?.value)?.kind ?? 'column';
        return CHART_KIND_OPTIONS.find(option => option.key === kind)?.labelKey ?? '';
    });

    public blocked = computed(
        () =>
            this._editService.loading() ||
            this._editDataService.currentSessionIsDisabled() ||
            this._editDataService.documentIsBlocked()
    );

    public open(step: ChartWizardStep): void {
        const id = this.field()?._id;
        if (!id || this.blocked() || this.type() !== CardTypes.DEFAULT) return;
        this._wizard.openEdit(id, step);
    }
}
